import { formatDate, parseISO } from '../../utils/date'

export function formatContainerSize(value: string) {
  if (!value) return '-'
  if (value.length === 2) return value + '`'
  if (value.length === 4) return value.slice(0, 2) + '` ' + value.slice(2)
}

export function formatVesselETADate(value?: string) {
  if (!value) return '-'
  return formatDate(parseISO(value), "EEE, MMM dd 'at' hh:mm")
}

export function formatNonRequiredContainerField(value?: string) {
  if (!value) return '-'
  return value
}

export function formatDrayageShipmentDirection(value?: string) {
  if (!value) return '-'
  return value === 'load_import' ? 'Import' : 'Export'
}
